import React from 'react';
import type { MetaTagsState } from './MetaTags';

export class MetaTagsClient {
    canonical?: string;
    description?: string;
    robots?: string;
    title?: string;
    breadcrumbs?: string;

    constructor(state: MetaTagsState = {}) {
        this.canonical = state.canonical;
        this.description = state.description;
        this.robots = state.robots;
        this.title = state.title;
        this.breadcrumbs = state.breadcrumbs;
    }

    public dehydrate(): MetaTagsState {
        return {
            canonical: this.canonical,
            description: this.description,
            robots: this.robots,
            title: this.title,
            breadcrumbs: this.breadcrumbs,
        };
    }
}

export const MetaTagClientContext = React.createContext<
    { metaTagsClient: MetaTagsClient } | undefined
>(void 0);

type MetaTagsClientProviderProps = {
    children: React.ReactNode;
    client: MetaTagsClient;
};

export function MetaTagsClientProvider(props: MetaTagsClientProviderProps) {
    const { children, client } = props;

    const value = React.useMemo<{ metaTagsClient: MetaTagsClient }>(
        () => ({
            metaTagsClient: client,
        }),
        [client],
    );

    return (
        <MetaTagClientContext.Provider value={value}>
            {children}
        </MetaTagClientContext.Provider>
    );
}

export function useMetaTagsClient() {
    const context = React.useContext(MetaTagClientContext);
    if (typeof context === 'undefined') {
        throw new Error(
            'useMetaTagsClient must be used within an MetaTagsClientProvider',
        );
    }
    return context;
}
